const cookiePolicy = [
  {
    heading: 'Cookie Policy',
    topParagraphs: [
      'Cookies are small text files that are placed on your computer by websites that you visit. They are widely used in order to make websites work, or work more efficiently, as well as to provide information to the owners of the site. We use the following cookies:',
    ],
    bullets: [
      'Entrepreneur Seminar: The only value we store ourselves is the token used to identify you once you have signed in to your account.',
      'Google Analytics: This service allows us to measure engagement with our website and other apps to improve our services and provide the most relevant content. Google Analytics  tracks usage of the site with cookies.',
      'Facebook Pixel Tracking: Companion engagement tracking for the same purpose as Google Analytics.',
      'Stripe: Secure card payments are provided by Stripe. They use the Stripe Radar service to track website engagement to improve their fraud detection efforts.',
    ],
    bottomParagraphs: [
      'Most web browsers allow some control of most cookies through the browser settings. Please use your browser settings to disable cookies if you do not wish to have cookies stored on your device.',
    ],
  },
]

export default cookiePolicy
